import { BackImageBox } from './styles';
import backSrc from './resources/back-spring.png';

export const BackImage = () => {
    return (
        <BackImageBox src={backSrc} />
    );
}
